const SERVER_ORIGIN_KEY = 'clawlet.serverOrigin';
const DEFAULT_SERVER_ORIGIN = 'https://clawlet.robbieai.com';

function normalizeOrigin(value: string): string | null {
  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
}

function getWindowOrigin(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return normalizeOrigin(window.location.origin)
    ?? normalizeOrigin(`${window.location.protocol}//${window.location.host}`);
}

export function getStoredServerOrigin(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = window.localStorage.getItem(SERVER_ORIGIN_KEY);
    return stored ? normalizeOrigin(stored) : null;
  } catch {
    return null;
  }
}

export function persistServerOrigin(origin: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  const normalized = normalizeOrigin(origin);
  if (!normalized) {
    return;
  }

  try {
    window.localStorage.setItem(SERVER_ORIGIN_KEY, normalized);
  } catch {
    // Ignore persistence failures.
  }
}

export function serverOriginFromGatewayUrl(gatewayUrl: string): string | null {
  try {
    const parsed = new URL(gatewayUrl);
    const protocol = parsed.protocol === 'wss:' ? 'https:' : parsed.protocol === 'ws:' ? 'http:' : parsed.protocol;
    return `${protocol}//${parsed.host}`;
  } catch {
    return null;
  }
}

export function persistServerOriginFromGatewayUrl(gatewayUrl: string): void {
  const origin = serverOriginFromGatewayUrl(gatewayUrl);
  if (origin) {
    persistServerOrigin(origin);
  }
}

export function getServerOrigin(gatewayUrl?: string): string {
  return (
    getStoredServerOrigin()
    ?? (gatewayUrl ? serverOriginFromGatewayUrl(gatewayUrl) : null)
    ?? getWindowOrigin()
    ?? DEFAULT_SERVER_ORIGIN
  );
}

export function getGatewayUrlForCurrentServer(gatewayUrl?: string): string {
  const origin = getServerOrigin(gatewayUrl);
  const parsed = new URL(origin);
  const protocol = parsed.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${parsed.host}/gateway/`;
}

export function buildApiUrl(path: string, gatewayUrl?: string): string {
  return new URL(path, getServerOrigin(gatewayUrl)).toString();
}

export function buildWebSocketUrl(path: string, gatewayUrl?: string): URL {
  const url = new URL(path, getServerOrigin(gatewayUrl));
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url;
}
